const updateCronTemplate = async ({ params, api }) => {
  const { previousData } = params;
  const { id } = previousData;
  return await api(`cronTemplate/${id}`, { body: params.data, method: 'PUT' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default updateCronTemplate;